module.exports = __webpack_public_path__ + "static/media/mic.37c1a5d7.svg";